<template>
  <div class="app-breadcrumbs">
    <div class="items">

      <!-- Menu -->
      <div
        v-if="isAdmin"
        class="btn-menu"
        @click.stop="$emit('toggle-menu')"
      >
        <span class="i-header-menu"></span>
      </div>

      <!-- Breadcrumb Items -->
      <div
        v-for="(item, index) in breadcrumb"
        class="item"
        :key="index">
        <div
          class="item-btn"
          :class="{ 'item-btn__active': isActive(index) }"
          @click="onItemClick(item, index)"
        >
          {{ item.title | translate }}
        </div>

        <!-- Arrow separator -->
        <div
          v-if="index < breadcrumb.length - 1"
          class="splitter">
          <span class="i-header-breadcrumb-arrow"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapActions } from 'vuex'
import { getFarmPath } from '@/util/app.js'

export default {
  name: 'AppBreadcrumbs',

  data: () => ({
    prevFarmId: null,
    farmName: null,

    breadcrumb: []
  }),

  mounted () {
    this.buildBreadcrumbs()
  },

  methods: {
    ...mapActions('farms', [
      'getFarm'
    ]),

    isActive (index) {
      if (!this.isClient && this.$route.path.includes('consultants')) {
        return false
      }
      return !this.$route.path.includes('admin') &&
        index === this.breadcrumb.length - 1
    },

    async getCompanyName (id) {
      const KEY = `company_${id}_name`
      const restored = sessionStorage.getItem(KEY)
      if (restored) {
        return restored
      }
      const { data, errors } = await api.companies.getById(id)
      if (!errors) {
        sessionStorage.setItem(KEY, data.name)
        return data.name
      }
      return 'Company'
    },

    async getFarmName (id) {
      const KEY = `farm_${id}_name`
      const restored = sessionStorage.getItem(KEY)
      if (restored) {
        return restored
      }
      const { data, errors } = await api.farms.getById(id)
      if (!errors) {
        sessionStorage.setItem(KEY, data.name)
        return data.name
      }
      return 'Farm'
    },

    async buildBreadcrumbs () {
      const breadcrumbTmp = []

      // CLIENTS
      if (!this.isClient) {
        const item = {
          title: 'base.clients',
          path: '/app/clients'
        }
        breadcrumbTmp.push(item)
      }

      // COMPANIES
      if (this.$route.path.startsWith('/app')) {
        const clientId = this.$route.params.client_id
        const item = {
          title: 'base.companies',
          path: this.isClient
            ? '/app/companies'
            : `/app/clients/${clientId}/companies`
        }
        breadcrumbTmp.push(item)
      }

      // COMPANY ID
      const companyId = +this.$route.params.company_id
      if (companyId) {
        const clientId = this.$route.params.client_id
        const item = {
          title: await this.getCompanyName(companyId),
          path: this.isClient
            ? `/app/companies/${companyId}`
            : `/app/clients/${clientId}/companies/${companyId}`
        }
        breadcrumbTmp.push(item)
      }

      // FARM
      const farmId = this.$route.params.farm_id
      if (farmId) {
        const item = {
          title: await this.getFarmName(farmId),
          path: getFarmPath(null, this.$route, 'planning')
        }
        breadcrumbTmp.push(item)
      }

      this.breadcrumb = breadcrumbTmp
    },

    onItemClick (item, index) {
      if (!this.isActive(index)) {
        this.$router.push(item.path)
      }
    }
  },

  watch: {
    '$route.path' () {
      this.buildBreadcrumbs()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';
  
.app-breadcrumbs {
  height: 7rem;
  margin-left: 14rem;
  width: 100%;
  padding-right: 30rem;
  @media screen and (max-width: 1600px) {
    margin-left: 7rem;
  }
  @media screen and (max-width: 1400px) {
    margin-left: 3rem;
  }

  .items {
    display: flex;

    .item {
      display: flex;
      align-items: baseline;
    }
  }
}

.btn-menu {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-top: .5rem;
}

.item-btn {
  cursor: pointer;
  list-style: none;
  display: inline-block;
  font-size: 1.7rem;
  font-weight: 700;
  padding-top: 29px;
  padding-bottom: 19px;
  margin-right: 30px;
  margin-left: 30px;
  border-bottom: 4px solid transparent;
  
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 450px;
   
  @media screen and (max-width: 1900px) {
 
    margin-right: 12px;
    margin-left: 12px;
  }
  @media screen and (max-width: 1800px) {

    font-size: 1.5rem;
    max-width: 350px;
  }
  @media screen and (max-width: 1500px) {
    max-width: 300px;
  }
  @media screen and (max-width: 1350px) {
    font-size: 1.4rem;
    max-width: 250px;
  }
  @media screen and (max-width: 1250px) {
    max-width: 200px;
  }
  @media screen and (max-width: 1150px) {
    max-width: 150px;
  }
  

  &__active {
    cursor: default;
    border-bottom: 4px solid var(--color-primary);
  }
}
</style>
